import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import styled from "styled-components";
import _ from "lodash";
import nanoid from "nanoid";

import { IconButton } from "material-ui";
import Chat from "material-ui/svg-icons/communication/chat";
import Clear from "material-ui/svg-icons/content/clear";

import SupportChatInput from "./SupportChatInput";
import SupportChatMessage from "./SupportChatMessage";
import fbApi from "../../firebaseApi";
import { pompadour } from "../../colors";

const SUPPORT_RECIPIENT_ID = "301";

class SupportChat extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, messages: [] };
    console.log("ASDBG chat", props.chat, window.store.getState().chats);
    if (props.chat) {
      this.loadMessages();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.chat && !this.props.chat) {
      this.loadMessages();
    }
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  loadMessages() {
    const messagesId = `venue${this.props.venueId}_${SUPPORT_RECIPIENT_ID}`;
    fbApi.loadMessages(messagesId, (rawMessages) => {
      let messages = [];
      Object.keys(rawMessages).forEach((ind) => {
        messages.push({ ...rawMessages[ind], id: ind });
      });
      messages = messages.sort((a, b) => b.timestamp - a.timestamp);
      console.log("ASDBG messages", messages);
      this.setState({
        messages: messages.reverse(),
      });
    });
  }

  scrollToBottom = () => {
    this.chat.scrollTop = this.chat.scrollHeight;
  };

  sendMessage = (msg) => {
    if (!this.props.chat) {
      fbApi.activateSupportUser(SUPPORT_RECIPIENT_ID, msg, () => fbApi.loadChats());
    } else {
      const messagesId = `venue${this.props.venueId}_${SUPPORT_RECIPIENT_ID}`;
      fbApi.sendMessage(SUPPORT_RECIPIENT_ID, messagesId, msg);
    }
  };

  render() {
    const { t } = this.props;
    const { isOpen, messages } = this.state;

    return (
      <SupportChatContainer>
        <CollapsableContainer isOpen={isOpen}>
          <CollapsableContainerHeader>{t("Чат с поддержкой ASAP")}</CollapsableContainerHeader>
          <MessageWrapper
            innerRef={(node) => {
              this.chat = node;
            }}
          >
            {_.map(messages, message => <SupportChatMessage key={nanoid()} message={message} />)}
          </MessageWrapper>
          <SupportChatInput sendMessage={msg => this.sendMessage(msg)} />
        </CollapsableContainer>
        <SupportChatHeader isOpen={isOpen}>
          <SupportChatHeaderButton onClick={() => this.setState({ isOpen: !isOpen })}>
            {isOpen ? null : <span style={{ paddingLeft: 15 }}>{t("Техподдержка ASAP")}</span>}
            <IconButton
              style={{
                borderRadius: 64,
                backgroundColor: pompadour,
                width: 64,
                height: 64,
              }}
              iconStyle={{ width: 36, height: 36 }}
            >
              {isOpen ? <Clear color="white" /> : <Chat color="white" />}
            </IconButton>
          </SupportChatHeaderButton>
        </SupportChatHeader>
      </SupportChatContainer>
    );
  }
}

const SupportChatContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  min-height: 64px;
  z-index: 100;
  margin: 0;
  margin-left: 40px;
`;

const SupportChatHeader = styled.div`
  border: 0px;
  padding: 0;
  padding-top: 10px;
  margin: 0;
  width: 100%;
  display: flex;
  background-color: transparent;
  justify-content: flex-end;
`;

const SupportChatHeaderButton = styled.button`
  background-color: ${pompadour};
  color: white;
  display: flex;
  align-items: center;
  border-radius: 64px;
  font-size: 16pt;
  border: none;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
`;

const CollapsableContainer = styled.div`
  display: ${props => (props.isOpen ? "block" : "none")};
  background-color: white;
  border: none;
  color: black;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
`;

const CollapsableContainerHeader = styled.div`
  width: 100%;
  text-align: center;
  background-color: ${pompadour};
  padding: 10px 0;
  color: white;
`;

const MessageWrapper = styled.div`
  width: 80vw;
  max-width: 600px;
  max-height: 400px;
  min-height: 100px;
  overflow-y: scroll;
  background-color: rgba(0, 0, 0, 0.05);
`;

const mapStateToProps = state => ({
  chat: _.find(state.chats, { recipientId: SUPPORT_RECIPIENT_ID }),
  venueId: state.settings.venue_id,
});

export default connect(mapStateToProps)(translate()(SupportChat));



// WEBPACK FOOTER //
// ./src/containers/SupportChat/SupportChat.js